function initDesktopSearch () {
  const trigger = document.querySelector('.header__custom__top__search button'),
    target = document.querySelector('.mobile-search'),
    overlay = target.querySelector('.search-results-overlay'),
    close = document.querySelector('.search-close');

  overlay.addEventListener('click', (e) => {
    target.querySelector('.search-results-overlay').classList.remove('active');
    target.classList.remove('open');
  });
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    if (target.classList.contains('open')) {
      target.querySelector('.search-results-overlay').classList.remove('active');
      target.classList.remove('open');
      return;
    }
    target.classList.add('open');
    target.querySelector('input').focus();
  });
  close.addEventListener('click', (e) => {
    e.preventDefault();
    target.querySelector('.search-results-overlay').classList.remove('active');
    target.classList.remove('open');
  });
}

function initJumpToBar () {
  const select = document.querySelector('.jump-to-bar select'),
    links = document.querySelectorAll('.jump-to-bar ul a');

  if (!select || links.length <= 0) return;

  const jumpTo = (e) => {
    e.preventDefault();
    const hash = (e.target.nodeName === 'A' ? e.target.href.substring(e.target.href.indexOf('#') + 1) : e.target.options[e.target.selectedIndex].value);
    const el = document.getElementById(hash);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  select.addEventListener('change', jumpTo);
  links.forEach((link) => link.addEventListener('click', jumpTo));
}


document.addEventListener('DOMContentLoaded', () => {
  initDesktopSearch();
  initJumpToBar();
});
